/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Segment, Dimmer, Loader } from 'semantic-ui-react';
import { selectCurrentUserApiToken } from '../slices/currentUser/currentUserSlice';
import { changeBrowserTabTitle } from '../slices/browserTabTitle/browserTabTitleSlice';

// eslint-disable-next-line no-empty-pattern
const TestingSpacePage = ({ }) => {
    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR Testing Page"));
    }, []);

    return <div>
        <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
            {apiToken ?
                <></>
                :
                <p>Please login. (If you do not have an account click Sign In and log in with your Google Account.)</p>
            }
        </Segment>
    </div>
};

export default TestingSpacePage;